module.exports = __webpack_public_path__ + "img/icon-warning-triangle.7b93d15c.svg";